import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DropDownModel } from '../../../../../domain/model/common/dropDownModel';
import { GooglePlacesService } from '../../../../../domain/service/GooglePlaceService';
import { atLeastOneRequiredTrueValidator } from '../../../../../custom-validators/at-least-one-is-required-true-validator';
import { TaxRepresentative } from '../../../../../domain/model/properties/taxRepresentative';
import { PropertyAccount } from '../../../../../domain/model/profile/propertyAccount';

@Component({
  selector: 'app-rental-property-reporting-form',
  templateUrl: './rental-property-reporting-form.component.html',
  styleUrl: './rental-property-reporting-form.component.css'
})
export class RentalPropertyReportingFormComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() rentalPropertyReporting!: FormGroup;
  constructor(private googlePlacesService: GooglePlacesService,private fb: FormBuilder) { }
  showTaxRepresentativeForm: boolean = false;
  suggestions: any[] = [];
  @Input() states: DropDownModel[] = [];
  @Input() taxRepresentative!: TaxRepresentative;
  @Input() propertyAccount!: PropertyAccount;

  ngOnInit(): void {

    this.rentalPropertyReporting.get('taxRepresentativeStreetAddress')?.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlaces(value).then((predictions: any) => {
          this.suggestions = predictions;
        });
      } else {
        this.suggestions = [];
      }
    });

    this.rentalPropertyReporting.get("isUsingTaxRepresentative")?.valueChanges.subscribe((value) => { 
      
      if (this.showTaxRepresentativeForm !== value) { 
        this.showAndHideTaxForm(value);
      }

      
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.showTaxRepresentativeForm = this.rentalPropertyReporting.get('isUsingTaxRepresentative')?.value ?? false;
    this.buildForm(this.taxRepresentative);

  }
  
  ngAfterViewInit(): void {
    this.showTaxRepresentativeForm = this.rentalPropertyReporting.get('isUsingTaxRepresentative')?.value ?? null;
    this.showAndHideTaxForm(this.rentalPropertyReporting.get('isUsingTaxRepresentative')?.value ?? null);
  }
  public showAndHideTaxForm(show: boolean) {

    if (show) {

      this.rentalPropertyReporting.get('taxRepresentativeFirstName')?.addValidators(Validators.required);
      this.rentalPropertyReporting.get('taxRepresentativeFirstName')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeLastName')?.addValidators(Validators.required);
      this.rentalPropertyReporting.get('taxRepresentativeLastName')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeEmail')?.addValidators(Validators.required);
      this.rentalPropertyReporting.get('taxRepresentativeEmail')?.addValidators(Validators.email);
      this.rentalPropertyReporting.get('taxRepresentativeEmail')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.addValidators(Validators.required);
      this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.addValidators(Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/));
      this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeStreetAddress')?.addValidators(Validators.required);
      this.rentalPropertyReporting.get('taxRepresentativeStreetAddress')?.updateValueAndValidity();



      this.rentalPropertyReporting.get('taxRepresentativeCity')?.addValidators(Validators.required);
      this.rentalPropertyReporting.get('taxRepresentativeCity')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeState')?.addValidators(Validators.required);
      this.rentalPropertyReporting.get('taxRepresentativeState')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.addValidators(Validators.required);
      this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.addValidators(Validators.maxLength(12));
      this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.addValidators(Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/));
      this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.updateValueAndValidity();

      this.rentalPropertyReporting.setValidators(atLeastOneRequiredTrueValidator('sendToOwner', 'sendToReportingRep'));
      this.rentalPropertyReporting.updateValueAndValidity();
    } else {
      this.rentalPropertyReporting.get('taxRepresentativeFirstName')?.clearValidators();
      this.rentalPropertyReporting.get('taxRepresentativeFirstName')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeLastName')?.clearValidators();
      this.rentalPropertyReporting.get('taxRepresentativeLastName')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeEmail')?.clearValidators();
      this.rentalPropertyReporting.get('taxRepresentativeEmail')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.clearValidators();
      this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeStreetAddress')?.clearValidators();
      this.rentalPropertyReporting.get('taxRepresentativeStreetAddress')?.updateValueAndValidity();


      this.rentalPropertyReporting.get('taxRepresentativeCity')?.clearValidators();
      this.rentalPropertyReporting.get('taxRepresentativeCity')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeState')?.clearValidators();
      this.rentalPropertyReporting.get('taxRepresentativeState')?.updateValueAndValidity();

      this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.clearValidators();
      this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.updateValueAndValidity();

      this.rentalPropertyReporting.clearValidators();
      this.rentalPropertyReporting.updateValueAndValidity();
    }
    this.showTaxRepresentativeForm = show

  }
  async selectPlace(place: any) {

    this.suggestions = [];
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);

    if (selectedZipCode.zip) {
      this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.setValue(selectedZipCode.zip);
    }

    if (selectedZipCode.city) {
      this.rentalPropertyReporting.get('taxRepresentativeCity')?.setValue(selectedZipCode.city);
    }

    if (selectedZipCode.stateCode) {
      let stateId = this.states.find(e => e.iso2 == selectedZipCode.stateCode)?.id ?? 0;
      this.rentalPropertyReporting.get('taxRepresentativeState')?.setValue(stateId);
    }

    if (selectedZipCode.address) {
      this.rentalPropertyReporting?.get('taxRepresentativeStreetAddress')?.setValue(selectedZipCode.address);
      this.rentalPropertyReporting?.get('taxRepresentativeStreetAddress')?.updateValueAndValidity();
      this.rentalPropertyReporting?.get('taxRepresentativeStreetAddress')?.markAsUntouched();
    }
  }

  private buildForm(data: TaxRepresentative | undefined): void { 
 
    if (this.taxRepresentative != null){
      this.showAndHideTaxForm(this.propertyAccount.isUsingTaxRepresentative);
      this.rentalPropertyReporting =this.fb.group({
        isUsingTaxRepresentative: new FormControl(this.propertyAccount.isUsingTaxRepresentative),
        sendToOwner: new FormControl(this.propertyAccount.correspondenceToOwner),
        sendToReportingRep: new FormControl(this.propertyAccount.correspondenceToReportingRepresentative),
        taxRepresentativeFirstName: new FormControl(data?.firstName),
        taxRepresentativeLastName: new FormControl(data?.lastName),
        taxRepresentativeEmail: new FormControl(data?.email),
        taxRepresentativePhoneNumber: new FormControl(data?.phoneNumber),
        taxRepresentativeStreetAddress:new FormControl(data?.streetAddress),
        taxRepresentativeAptUnitSuite:new FormControl(data?.aptUnitSuite),
        taxRepresentativeCity:new FormControl(data?.city),
        taxRepresentativeState:new FormControl(data?.state),
        taxRepresentativeZipCode:new FormControl(data?.zipCode),
      });
    }

  }
}
